module.exports = __webpack_public_path__ + "resources/img/img-glassdome-omnibus-m.051fbf5acdcb734e80f37ea4503bc948.png";